import copy from "../assets/copy/copy.json";

const onCalendarIconClick = (fieldId) =>{
    const dateInput = document.getElementById(fieldId);
    if (dateInput) {
      dateInput.focus();
    } else {
      console.error(`Input element with ID ${fieldId} not found`);
    }
};

const getOrdinalSuffix = (number) => {
  const suffixes = {
    one: "st",
    two: "nd",
    few: "rd",
    other: "th"
  };
  const suffix = suffixes[new Intl.PluralRules("en", {
    type: "ordinal"
  }).select(number)];
  return (number + suffix);
}
/* agency qualifications
 * @param {string} agency - The agency to get the qualifications for.
 * @returns {array} - The list of qualificaton of the agency.
 */
const getAgencyQualifications = async (agency, Requests) => {
  try {
    const data = await Requests.callAPI(
      Requests.getQualification
    );
    if (data && data.status === 200) {
      const qualifications = data.data;
      const qualificationList = qualifications
      .filter((qualification) => qualification.agency === agency)
      .map((qualification) => ({
        key: qualification.code,
        value: qualification.id,
        text: qualification.name,
      }))
      .sort((a, b) => a.text.localeCompare(b.text));
      return qualificationList;
    } else {
      const errorMessage =
        copy.availability.qualifications.getQualInfoAPIErrorMessage +
        ` (Error #${copy.errorCodes.getQualInfoAPIErrorMessage})`;
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error("Error fetching qualifications:", error);
    throw error;
  }
}

export { onCalendarIconClick, getOrdinalSuffix, getAgencyQualifications };